export default {
    lineRegisterCode: 'Line Register Code',
    code: 'Code',
    create: 'Create',
    cancel: 'Cancel'
}
